import type {MySongsPageReducer} from "../../mySongsPage.types";

export interface IToggleFilterDifficultyCategoryPayload {
  difficultyCategoryId: number;
  difficultyIds: number[];
}

export const selectFilterDifficultyCategoryIdCaseReducer: MySongsPageReducer<IToggleFilterDifficultyCategoryPayload> = (store, action) => {
  const {difficultyCategoryId, difficultyIds} = action.payload;

  const difficultyCategories = [
    ...(store.difficulty?.difficultyCategories ?? []),
    difficultyCategoryId,
  ];

  const difficulties = Array.from(
    (new Set([...(store.difficulty?.difficulties ?? []), ...difficultyIds]))
      .values()
  );

  return {
    ...store,
    difficulty: {
      ...store.difficulty,
      difficultyCategories,
      difficulties,
    },
  };
};


export const unselectFilterDifficultyCategoryIdCaseReducer: MySongsPageReducer<IToggleFilterDifficultyCategoryPayload> = (store, action) => {
  const {difficultyCategoryId, difficultyIds} = action.payload;

  const difficultyCategories = [...(store.difficulty?.difficultyCategories ?? []),]
    .filter((storeDifficultyCategoryId) => storeDifficultyCategoryId !== difficultyCategoryId);

  const difficulties = [...(store.difficulty?.difficulties ?? []),]
    .filter((difficultyId) => !difficultyIds.includes(difficultyId));

  return {
    ...store,
    difficulty: {
      ...store.difficulty,
      difficultyCategories,
      difficulties,
    },
  };
};
